import React from "react";

const LanguageSwitch = ({changeLanguage}) => {
  return (
    <div className="mobileSettings-languageSwitch-wrapper">
      <p className="switch-text">Switch your questions language</p>
      <div className="language-switchBtn-wrapper">
        <button
          className={
            localStorage.language != "en" ? "switch-btn-selected" : "switch-btn"
          }
          onClick={() => changeLanguage("ml")}
        >
          MALAYALAM
        </button>
        <button
          className={
            localStorage.language == "en" ? "switch-btn-selected" : "switch-btn"
          }
          onClick={() => changeLanguage("en")}
        >
          ENGLISH
        </button>
      </div>
    </div>
  );
};

export default LanguageSwitch;
